import classNames from "classnames";
import React from "react";
import styles from "./agentControlCircle.css";

interface Props {
  disabled?: boolean;
  onClick: any;
  id?: string;
  buttonStyle: {
    off?: boolean;
    red?: boolean;
    small?: boolean;
    permissionDenied?: boolean;
    bright?: boolean;
    green?: boolean;
  };
}

export const AgentControlCircle: React.SFC<Props> = ({
  onClick,
  id,
  buttonStyle,
  disabled,
  children
}) => (
  <button
    className={classNames(styles.control, {
      [styles.off]: buttonStyle.off,
      [styles.red]: buttonStyle.red,
      [styles.small]: buttonStyle.small,
      [styles.permissionDenied]: buttonStyle.permissionDenied,
      [styles.bright]: buttonStyle.bright,
      [styles.green]: buttonStyle.green
    })}
    onClick={onClick}
    id={id}
    disabled={disabled}
  >
    {children}
  </button>
);
